export default "__VITE_ASSET__0f035a15__"